import { OptionsIcon } from "assets/icons/OptionsIcon";
import { ModalDelete } from "components/ModalDelete/ModalDelete";
import { OpcionPedagogicaI } from "interfaces/OpcionPedagogica";
import { TituloI } from "interfaces/Titulo";
import { ReactNode, useState } from "react";
import { Badge, Dropdown } from "react-bootstrap";
import { formatDate } from "utils/formatUtils";

interface Props {
  elemento: OpcionPedagogicaI;
  renderActions?: (elemento: OpcionPedagogicaI) => ReactNode;
}

export const OpcionPedagogicaRow = ({ elemento, renderActions }: Props) => {
  return (
    <>
      <tr className="table-row" key={`ResolucionTable-${elemento.id}`}>
        <td>{elemento.id}</td>
        <td>{elemento.nombre}</td>
        {renderActions && (
          <td style={{ maxWidth: "50px" }}>{renderActions(elemento)}</td>
        )}
      </tr>
    </>
  );
};
